// @ts-check
import React from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './store.js';

export default function App() {
  const { role, clear } = useAuth();
  const nav = useNavigate();
  return (
    <div className="flex h-screen">
      <aside className="w-56 bg-neutral-900 border-r border-neutral-800 flex flex-col">
        <div className="p-4 border-b border-neutral-800">
          <div className="font-bold text-red-500">Katsura HQ</div>
          <div className="text-xs text-neutral-500">{role}</div>
        </div>
        <nav className="flex-1 p-2 space-y-1">
          <Link to="/" className="block px-3 py-2 rounded hover:bg-neutral-800">Dashboard</Link>
          <Link to="/branches" className="block px-3 py-2 rounded hover:bg-neutral-800">Branches</Link>
          <Link to="/help" className="block px-3 py-2 rounded hover:bg-neutral-800">Help & Tutorials</Link>
        </nav>
        <button
          onClick={() => { clear(); nav('/login'); }}
          className="m-3 px-3 py-2 rounded bg-neutral-800 hover:bg-neutral-700"
        >
          Sign out
        </button>
      </aside>
      <main className="flex-1 overflow-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
